import { g as m, f as c, b as f, _ as l } from "./export-cdcbfb2b.js";
import { t as u } from "./to-string-92a62764.js";
import { s as b, w as I } from "./string-trim-14e37ad3.js";
var n = m, $ = c, g = f, h = u, x = b.trim, t = I, r = n.parseInt, s = n.Symbol, e = s && s.iterator, o = /^[+-]?0x/i, T = g(o.exec), S = r(t + "08") !== 8 || r(t + "0x16") !== 22 || e && !$(function() {
  r(Object(e));
}), y = S ? function(v, p) {
  var a = x(h(v));
  return r(a, p >>> 0 || (T(o, a) ? 16 : 10));
} : r, w = l, i = y;
w({ global: !0, forced: parseInt !== i }, {
  parseInt: i
});
export {
  y as n
};
